/*jslint browser */
/*global process */

import AdminBarController from "./controller/admin.bar.controller";
import AbstractRouting from "./abstract.routing";
import AdminBarView from "./view/admin.bar.view";
import DumpService from "./service/dump.service";

var $ = jQuery;
declare var document: any;

/**
 *
 */
export default class Routing extends AbstractRouting
{
    /**
     *
     * @param app
     * @private
     */
    protected execute(app: string): void {
        switch (app) {
            case 'admin-bar':
                new AdminBarController(new AdminBarView(), new DumpService());
                break;
        }
    }
}